<template>
  <div>
    <b-modal
      id="HistoryModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal rh-modal"
      title="Release History"
      hide-footer

      @show="getHistory()"
    >
      <vue-bootstrap4-table
        :rows="releaseRows"
        :columns="releaseColumns"
        :config="config"
        :classes="classes"
      >
      </vue-bootstrap4-table>
    </b-modal>
  </div>
</template>

<style>
.rh-modal .menu-bg-blue-transparent,
.rh-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}

/* ===== Search bar row ===== */
.rh-modal .vbt-global-search-row,
.rh-modal .row.vbt-global-search {
  margin-bottom: 0.85rem !important;
}
.rh-modal .global_search input,
.rh-modal input[type="text"].form-control {
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  border-radius: 999px !important;
  background: #fff !important;
  color: #063c6d !important;
  box-shadow: none !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.rh-modal .global_search input:focus,
.rh-modal input[type="text"].form-control:focus {
  border-color: #0a5490 !important;
  box-shadow: 0 0 0 0.15rem rgba(10, 84, 144, 0.15) !important;
}

/* ===== Table container ===== */
.rh-modal table {
  color: #063c6d !important;
  text-shadow: none !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  width: 100% !important;
  border: 1px solid rgba(6, 60, 109, 0.12) !important;
  border-radius: 0.75rem !important;
  overflow: hidden !important;
}

/* ===== Header ===== */
.rh-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border: none !important;
  border-bottom: 2px solid rgba(6, 60, 109, 0.15) !important;
  padding: 0.75rem 1rem !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
  white-space: nowrap;
}
.rh-modal thead th a,
.rh-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }

/* ===== Body ===== */
.rh-modal tbody tr {
  color: #063c6d !important;
  text-shadow: none !important;
  transition: background 0.15s ease;
}
.rh-modal tbody tr:nth-child(even) { background: rgba(6, 60, 109, 0.025) !important; }
.rh-modal tbody tr:hover { background: rgba(6, 60, 109, 0.07) !important; }
.rh-modal tbody td {
  color: #063c6d !important;
  border: none !important;
  border-bottom: 1px solid rgba(6, 60, 109, 0.08) !important;
  padding: 0.7rem 1rem !important;
  vertical-align: middle !important;
  font-size: 0.85rem;
  line-height: 1.5;
}
.rh-modal tbody tr:last-child td { border-bottom: none !important; }

/* Version — emphasized */
.rh-modal tbody td:nth-child(1) {
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* Release Date — muted, single line */
.rh-modal tbody td:nth-child(2) {
  color: rgba(6, 60, 109, 0.7) !important;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* Notes — comfortable, wrapping paragraph text */
.rh-modal tbody td:nth-child(3) {
  font-weight: 400;
  white-space: normal;
  word-break: break-word;
  line-height: 1.6;
}

/* ===== Pagination footer ===== */
.rh-modal .footer-pagination-row td,
.rh-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
  padding: 0.6rem 1rem !important;
}
.rh-modal .page-link {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.15) !important;
  background: #fff !important;
}
.rh-modal .page-item.active .page-link {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.rh-modal .page-link:hover { background: rgba(6, 60, 109, 0.08) !important; }
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
export default {
  name: 'MMP_ReleaseHistory',
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      releaseRows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      releaseColumns: [
        {
          label: 'Version',
          name: 'version',
          sort: true
        },
        {
          label: 'Release Date',
          name: 'release_date',
          sort: true
        },
        {
          label: 'Notes',
          name: 'notes',
          sort: false
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      }
    }
  },
  props: ['user'],
  methods: {
    getHistory() {
      if (sessionStorage.token) {
        if (this.user.org != '') {
          axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/getReleaseHistory',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                company_id: this.user.org
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(content.errors)
            } else {
              this.releaseRows = content.rows
              this.$bvModal.show('HistoryModal')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          console.log('No User Org Set')
        }
      } else {
        console.log('No User Token')
      }
    }
  }
}
</script>
